<template>
  <div>
    <el-row class="upload-section">
      <el-col :span="8">
        <span class="location-label">{{ $t('uploadUsers.locations') }}</span>
        <office-dropdown :selected="adminSelectedOffice" @change="onOfficeChanged" />
      </el-col>
      <el-col :span="8">
        <div class="button-wrapper">
          <el-button class="download-button centered-object" @click="openTemplates">
            {{ $t('uploadUsers.template') }}
          </el-button>
          <span class="hint-message">
            {{ $t('uploadUsers.templateHint') }}
          </span>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="button-wrapper">
          <user-file-uploader
            :accepted-file="fileType"
            :office-id="adminSelectedOffice"
            class="uploader-button"
          />
        </div>
      </el-col>
    </el-row>
    <el-row class="upload-section">
      <el-col class="upload-description">
        <h2 class="upload-description__title">{{ $t('uploadUsers.descriptionTitle') }}</h2>
        <div v-html="$t('uploadUsers.description')" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { BAMBOOHR_CSV_EXPORT } from '@/constants';
import UserFileUploader from '@/components/UserFileUploader';
import OfficeDropdown from '@/components/OfficeDropdown';

export default {
  name: 'UploadUserTab',
  components: {
    OfficeDropdown,
    UserFileUploader,
  },
  data() {
    return {
      fileType: '.csv',
    };
  },
  computed: {
    ...mapState('global', { adminSelectedOffice: 'adminSelectedOffice' }),
  },
  methods: {
    onOfficeChanged(office) {
      this.$emit('officechanged', office);
    },
    openTemplates() {
      window.open(BAMBOOHR_CSV_EXPORT, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';
.columnHeader {
  margin: 2em auto 1em;
}
.location-label {
  font-weight: $bold-font;
}
.button-wrapper {
  display: inline-block;
  width: 100%;
}
.download-button {
  width: 105px;
  display: block;
}
.hint-message {
  font-size: $label-description-text-size;
  text-align: center;
  color: $order-button-hint;
  margin-top: 7px;
  display: block;
}
.centered-object {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.upload-section {
  margin: 40px 200px;
  &.el-row {
    height: 100px;
  }
}
.upload-description {
  text-align: left;
  line-height: 2;
  &__title {
    margin-bottom: 20px;
    font-size: $subtitle-font-size;
    font-weight: $bold-font;
    margin-left: -20px;
  }
}
.uploader-button {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadUserTab.vue